// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { ActionIcon, Box, Group, Menu, Modal, Text } from '@mantine/core';
import { FC, useContext } from 'react';
import { IconChevronDown, IconSend } from '@tabler/icons';
import moment from 'moment';
import { useDisclosure } from '@mantine/hooks';
import Dot from '../../../Atoms/Dot';
import { RecommendationDto } from '../../../Types/RecommendationT';
import { Contact } from '../../../Service/ContactS';
import { RecommendationContext } from './RecommendationsPane';
import SendCustomerInfoMail from './Modals/SendCustomerInfoMail';

const ExportEventInfoStatus: FC<{ recommendation: RecommendationDto; contact: Contact }> = ({
  recommendation,
  contact,
}) => {
  const { lastContactShare } = recommendation;
  const [opened, { open, close }] = useDisclosure(false);
  const { patchRecommendation } = useContext(RecommendationContext);

  return (
    <Box
      p={5}
      pr="xs"
      pl="md"
      sx={(theme) => ({
        borderRadius: theme.spacing.xs,
        backgroundColor: theme.colorScheme !== 'dark' ? 'white' : 'black',
        fontSize: theme.fontSizes.xs,
      })}
    >
      <Group position="apart" noWrap>
        <Group>
          <Dot colour={lastContactShare ? '#4EBF46' : '#f44336'} />
          <Text weight="bolder">{`Kundeninfos ${lastContactShare ? 'geteilt' : 'noch nicht geteilt'}`}</Text>
        </Group>
        <Menu shadow="md" radius="md" width={230} position="bottom-end" transition="scale-y">
          <Menu.Target>
            <ActionIcon size="xs">
              <IconChevronDown size={16} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item icon={<IconSend size={16} />} onClick={open}>
              {`Kundeninfos ${lastContactShare ? 'erneut' : ''} teilen`}
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
      {lastContactShare && (
        <Text italic color="dimmed">{`am ${moment(lastContactShare).format('DD.MM.YY HH:mm')}`}</Text>
      )}

      <Modal
        closeOnClickOutside={false}
        size={550}
        transition="slide-down"
        opened={opened}
        onClose={close}
        title={
          <Text size="lg" weight="bolder">
            Auftragsdaten übermitteln
          </Text>
        }
      >
        <SendCustomerInfoMail
          recommendation={recommendation}
          patchRecommendation={patchRecommendation}
          recommendedContact={contact}
          closeModal={close}
        />
      </Modal>
    </Box>
  );
};

export default ExportEventInfoStatus;
